export enum categoryEnum {
    RM = 'RM',
    FG = 'FG',
}

export const categoryEnumDisplay = [
    { name: "RM", displayVal:'RM'},
    { name:'FG', displayVal:'FG'},
]
